"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateWitnessArgs = exports.defaultEmptyWitnessArgs = void 0;
const codec_1 = require("@ckb-lumos/codec");
const base_1 = require("@ckb-lumos/base");
exports.defaultEmptyWitnessArgs = codec_1.bytes.hexify(base_1.blockchain.WitnessArgs.pack({}));
/**
 * Update a property value of a WitnessArgs (in hex).
 */
function updateWitnessArgs(witness, key, value) {
    witness = witness && witness !== '0x' ? witness : exports.defaultEmptyWitnessArgs;
    return codec_1.bytes.hexify(base_1.blockchain.WitnessArgs.pack({
        ...base_1.blockchain.WitnessArgs.unpack(witness),
        [key]: value,
    }));
}
exports.updateWitnessArgs = updateWitnessArgs;
//# sourceMappingURL=witness.js.map